// assets/lazy-load-images.js
// Adds native lazy-loading to all <img> elements without a loading attribute
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('img:not([loading])').forEach(img => {
    img.setAttribute('loading', 'lazy');
  });
});
